export default function AgreementsTableRowsMapper(
  local,
  archive,
  agreementcategories,
  agreements,
  agreementstatuses,
  cities,
  city,
  district,
  districts,
) {
  let rows;
  if (agreementcategories && agreements && agreementstatuses && cities && districts) {
    rows = agreements
      .filter((agreement) => {
        const isDistrict = !district || district.id === agreement.district;
        const isCity = !city || city.id === agreement.city;
        const isActive = archive !== agreement.active;
        const agreementCategory = agreementcategories.find((item) => item.id === agreement.category);
        return isActive && isDistrict && isCity && agreementCategory.active;
      })
      .map((agreement) => {
        const itemDistrict = district || districts.find((item) => item.id === agreement.district);
        const itemCity = city || cities.find((item) => item.id === agreement.city);
        const itemCategory = agreementcategories.find((item) => item.id === agreement.category);
        const itemStatus = agreementstatuses.find((item) => item.id === agreement.status);
        return {
          id: agreement.id,
          district: itemDistrict ? itemDistrict.name : '',
          city: itemCity ? itemCity.name : '',
          until: agreement.until,
          category: itemCategory ? itemCategory.name : '',
          status: itemStatus ? itemStatus.name : '',
          creator: agreement.creator,
          createdAt: agreement.createdAt,
          editor: agreement.editor,
          updatedAt: agreement.updatedAt,
          description: agreement.description,
        };
      });
  }
  return rows;
}
